import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: ReactNode;
}

// Lightweight transition: no artificial delay. New page renders immediately
// and a quick CSS fade-in plays on top. Keyed on pathname so the animation
// re-triggers per route change.
const PageTransition = ({ children }: PageTransitionProps) => {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-transition animate-fade-in">
      {children}
    </div>
  );
};

export default PageTransition;
